export const AgruparWithLabel = (miArray, prop, label) => {
  if (miArray === undefined || miArray == null || miArray.lenght === 0)
    return [];
  var array = miArray.reduce(function (groups, item) {
    var val = item[prop];
    groups[val] = groups[val] || {
      id: val,
      label: item[label],
    };
    return groups;
  }, {});
  return Object.values(array);
};
